<template>
    <div class="panel panel-info">
        <div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>试题录入</h4></div>
        <div class="panel-body">
            <form class="form-horizontal">
                <!--试题类别-->
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-2 control-label" ><span class="required" >*</span>试题类别</label>
                            <div class="col-sm-10">
                                <select @change="selectStlb" name="stlb" v-model="model.stlb"  class="form-control" v-validate="{required:true,max:50}" data-vv-as="试题类别">
                                    <option value="">-请选择-</option>
                                    <option v-for="stlb in stlbList" :key="stlb.value" :value="stlb.value">{{stlb.text}}</option>
                                </select>
                                <span class="error_validate_msg"><em>{{ errors.first('stlb') }}</em></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-2 control-label" > <span class="required" >*</span>所属题库</label>
                            <div class="col-sm-10">
                                <select name="sstk" v-model="model.tkId" class="form-control" v-validate="{required:true,max:50}" data-vv-as="所属题库">
                                    <option value="">-请选择-</option>
                                    <option v-for="sstk in sstkList" :key="sstk.id" :value="sstk.id">{{sstk.tkmc}}</option>
                                </select>
                                <span class="error_validate_msg"><em>{{ errors.first('sstk') }}</em></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">试题来源</label>
                            <div class="col-sm-10">
                                <input type="text" v-model="model.stly" name="stly" oninput="if(value.length>10)value=value.slice(0,20)" placeholder="" class="form-control" data-vv-as="试题来源"  >
                            </div>
                        </div>
                    </div>

                    <!--试题状态-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-2 control-label" ><span class="required" >*</span>试题状态</label>
                            <div class="col-sm-10">
                                <select name="stzt" v-model="model.zt" class="form-control" v-validate="{required:true,max:50}" data-vv-as="试题状态">
                                    <option value="">请选择</option>
                                    <option v-for="stzt in stztList" :key="stzt.value" :value="stzt.value">{{stzt.text}}</option>
                                </select>
                                <span class="error_validate_msg"><em>{{ errors.first('stzt') }}</em></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-2 control-label"><span class="required" >*</span>试题难度</label>
                            <div class="col-sm-10">
                                <select name="stnd" v-model="model.stnd" class="form-control" v-validate="{required:true,max:50}" data-vv-as="试题难度">
                                    <option value="">请选择</option>
                                    <option v-for="stnd in stndList" :key="stnd.value" :value="stnd.value">{{stnd.text}}</option>
                                </select>
                                <span class="error_validate_msg"><em>{{ errors.first('stnd') }}</em></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-2 control-label"><span class="required" >*</span>题型名称</label>
                            <div class="col-sm-10">
                                <input type="text" v-model="model.tx" name="txmc" placeholder="" v-validate="{required:true,max:50}"  class="form-control" data-vv-as="题型名称"  >
                                <span class="error_validate_msg"><em>{{ errors.first('txmc') }}</em></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!--试题题干-->
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group" >
                            <label class="col-sm-1 control-label" style="margin-top: 90px;">试题题干</label>
                            <div class="col-sm-11">
                                <ck-editor id="ck_tigan" v-model="model.sttg"></ck-editor>
                            </div>
                        </div>
                    </div>
                </div>

                <!--选项设置单选-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='SINGLECHOICE'">
                        <div class="form-group" >
                            <table style="width:100%">
                                <tr>
                                    <td valign="middle" align="right" style="padding-left: 10px">
                                        <label class="col-sm-3 control-label">选项设置</label>
                                    </td>
                                    <td>
                                        <div class="col-sm-12">
                                            <div class="form-group" v-for="(item,index) in model.options" :key="'danxuan'+index">
                                                <label class="col-sm-1 demo--label" style="cursor:pointer">
                                                    <input class="demo--radio"  :value="letters[index]" type="radio" name="demo-radio" v-model="model.stda">
                                                    选项{{letters[index]}} <span class="demo--radioInput" style="margin-right: 2px"></span>
                                                </label>
                                                <div class="col-sm-10">
                                                    <ck-editor :id="'ck_options_dx_'+index"  v-model="item.text"></ck-editor>
                                                    <div class="text-center" v-if="index==model.options.length-1" style="margin-top:2px"><button type="button" class="btn btn-sm btn-primary" @click="addOption">继续添加选项</button></div>
                                                </div>
                                                <div class="col-sm-1" style="padding-top: 100px;padding-left:0px">
                                                    <button v-if="index > 0" @click="delOption(item,index)" type="button" style="margin-left:5px" class="btn btn-danger btn-sm" title="删除选项"><i class="fa fa-times" aria-hidden="true"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <!--选项设置多选-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='MULTIPLECHOICE'">
                        <div class="form-group" >
                            <table style="width:100%">
                                <tr>
                                    <td valign="middle" align="right" style="padding-left: 10px">
                                        <label class="col-sm-3 control-label">选项设置</label>
                                    </td>
                                    <td>
                                        <div class="col-sm-12">
                                            <div class="form-group" v-for="(item, index) in model.options" :key="'duoxuan'+index">
                                                <label class="col-sm-1 demo--label" style="cursor:pointer">
                                                    <label style="position: relative;bottom:5px;">选项{{letters[index]}}</label>&nbsp;&nbsp;<input type="checkbox" v-model="item.checked" style="cursor:pointer">
                                                </label>
                                                <div class="col-sm-10">
                                                    <ck-editor :id="'ck_options_duoxuan_'+index" v-model="item.text"></ck-editor>
                                                    <div class="text-center" v-if="index==model.options.length-1" style="margin-top:2px"><button type="button" class="btn btn-sm btn-primary" @click="addOption">继续添加选项</button></div>
                                                </div>
                                                <div class="col-sm-1" style="padding-top: 100px;padding-left:0px">
                                                    <button v-if="index > 0" @click="delOption(item,index)" type="button" style="margin-left:5px;" class="btn btn-danger btn-sm" title="删除选项"><i class="fa fa-times" aria-hidden="true"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <!--答案设置判断题-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='JUDGMENT'">
                        <div class="form-group" >
                            <label class="col-sm-1 control-label">答案设置</label>
                            <div class="col-sm-11">
                                <label class="demo--label_pd" style="cursor:pointer">
                                    <input class="demo--radio" v-model="model.stda" value="Y" type="radio" name="demo-radio">
                                    <span class="demo--radioInput"></span>正确
                                </label>
                                <label class="demo--label_pd" style="cursor:pointer">
                                    <input class="demo--radio" v-model="model.stda"  value="N" type="radio" name="demo-radio">
                                    <span class="demo--radioInput"></span>错误
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!--答案设置填空题-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='BLANKFILL'">
                        <div class="form-group">
                            <label class="col-sm-1 control-label">答案设置</label>
                            <div class="col-sm-11">
                                <button type="button" class="btn btn-primary btn-sm" @click="addtkt">增加填空</button>
                            </div>
                        </div>
                        <div class="form-group" v-if="tktList.length>0">
                            <label class="col-sm-1 control-label">填写答案</label>
                            <div class="col-sm-11" style="padding-left: 0px">
                                <template v-for = "(item,index) in tktList" >
                                    <div class="col-sm-3" v-if="!item.removed" :key = "'tkt_'+index">
                                        <table style="width: 100%;">
                                            <tr>
                                                <td>
                                                    <span>{{index+1}}、</span>
                                                </td>
                                                <td>
                                                    <input name="tksm" type="text" v-model="item.text"  placeholder=''  class="form-control" style="margin-bottom: 3px;">
                                                </td>
                                                <td>
                                                    <button @click="deltkt(item,index)" type="button" style="margin-left:1px;" class="btn btn-danger btn-sm" title="删除填空题"><i class="fa fa-times" aria-hidden="true"></i></button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <!--答案设置问答题-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='ESSAY'">
                        <div class="form-group" >
                            <label class="col-sm-1 control-label" style=" margin-top: 90px;">答案设置</label>
                            <div class="col-sm-11">
                                <ck-editor id="ck_wdt" v-model="model.stda"></ck-editor>
                            </div>
                        </div>
                    </div>
                </div>

                <!--答案设置名词解释题-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='MCJST'" >
                        <div class="form-group" >
                            <label class="col-sm-1 control-label" style=" margin-top: 90px;">答案设置</label>
                            <div class="col-sm-11">
                                <ck-editor id="ck_mcsjt" v-model="model.stda"></ck-editor>
                            </div>
                        </div>
                    </div>
                </div>

                <!--答案设置论述题-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='LST'">
                        <div class="form-group" >
                            <label class="col-sm-1 control-label" style=" margin-top: 90px;">答案设置</label>
                            <div class="col-sm-11">
                                <ck-editor id="ck_lst" v-model="model.stda"></ck-editor>
                            </div>
                        </div>
                    </div>
                </div>

                <!--答案设置简答题-->
                <div class="row">
                    <div class="col-sm-12" v-if="model.stlb=='JDT'">
                        <div class="form-group" >
                            <label class="col-sm-1 control-label" style=" margin-top: 90px;">答案设置</label>
                            <div class="col-sm-11">
                                <ck-editor id="ck_jdt" v-model="model.stda"></ck-editor>
                            </div>
                        </div>
                    </div>
                </div>
                <!--试题解析-->
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group" >
                            <label class="col-sm-1 control-label"  style=" margin-top: 90px;">试题解析</label>
                            <div class="col-sm-11">
                                <ck-editor id="ck_jiexi" v-model="model.stjx"></ck-editor>
                            </div>
                        </div>
                    </div>
                </div>
                <!--保存-->
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <div class="form-group">
                            <button @click="save()" type="button" class="btn btn-primary btn-sm " style="margin-right:3px;padding-left: 20px;padding-right: 20px;"><i class="" aria-hidden="true"></i>提交</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

    /**
     * 新增试题
     */
    export default {
        name:"QuesAdd",
        components:{
        },
        data:function(){
            return {
                letters:["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","X","Y","Z"],
                js:this.$store.state.user.js,
                SINGLECHOIC:true,
                stlbList:[],//试题类别
                sstkList:[],//题库
                stztList:[],//试题状态
                stndList:[],//试题难度
                blankList:[],
                tktList:[],//填空题
                model:{
                    stlb:'',
                    tx:'',
                    tkId:'',
                    stly:'原创',
                    zt:'OK',
                    stnd:'CG',
                    sttg:'',
                    stda:'',
                    options:[
                        {text:''},
                        {text:''},
                        {text:''},
                        {text:''}
                    ],
                    stjx:''
                },
            }
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'题库管理'},{name:'新增试题'}]);
            this.stlbList = [{value: 'SINGLECHOICE', text: '单选题'}, {value: 'MULTIPLECHOICE', text: '多选题'}, {value: 'JUDGMENT', text: '判断题'}, {value: 'BLANKFILL', text: '填空题'}, {value: 'ESSAY', text: '问答题'}, {value: 'MCJST', text: '名词解释题'}, {value: 'LST', text: '论述题'}, {value: 'JDT', text: '简答题'}, {value: 'TT', text: '套题'}];//试题类别
            this.getsstkList();//题库
            this.stztList = [{value: 'OK', text: '开放'}, {value: 'BLOCK', text: '关闭'}];//试题状态
            this.stndList = [{value: 'FCRY', text: '非常容易'}, {value: 'BJRY', text: '比较容易'}, {value: 'CG', text: '常规'}, {value: 'JN', text: '较难'}, {value: 'FCN', text: '非常难'}];//试题难度
        },
        methods: {
            selectStlb:function(){
                if(this.model.stlb){
                    let list = this.stlbList.filter(x=>x.value == this.model.stlb);
                    if(list && list.length>0){
                        this.model.tx = list[0].text;
                    }
                }
            },
            //题库下拉
            getsstkList:function(){
                this.$http.post('/htgl/zktk/st/hqtk').then(res=>{
                    this.sstkList = res.data;
					this.model.tkId = '';
                });
            },
            //新增多选题
            addOption:function(){
                this.model.options.push({text:''});
            },
            //删除多选题
            delOption:function(item,index){
                if(this.model.options && this.model.options.length > 1){
                    //从数组中删除下标为index的数据 删除1个
                    this.model.options.splice(index,1);
                }
            },
            //新增填空题
            addtkt:function(){
                let bname = "[BlankArea"+(this.tktList.length+1)+"]";
                this.tktList.push({text:''});
                console.log('----this model sttg:',this.model.sttg);
                this.model.sttg = this.model.sttg || '<p></p>';
                this.model.sttg = this.model.sttg.replace("</p>",bname+"</p>");
            },
            //删除填空题
            deltkt:function(item,index){
                if(this.tktList && this.tktList.length > 0){
                    //从数组中删除下标为index的数据 删除1个
                    this.tktList[index].removed=true;
                    this.model.sttg = this.model.sttg.replace("[BlankArea"+(index+1)+"]", "");
                }
            },
			reset:function(){
				    this.letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","X","Y","Z"];
				    this.SINGLECHOIC = true;
				    this.stlbList = [];//试题类别
				    this.sstkList = [];//题库
				    this.stztList = [];//试题状态
				    this.stndList = [];//试题难度
				    this.blankList = [];
				    this.tktList = [];//填空题
				    this.model = {
				        stlb:'',
				        tx:'',
				        tkId:'',
				        stly:'原创',
				        zt:'OK',
				        stnd:'CG',
				        sttg:'',
				        stda:'',
				        options:[
				            {text:''},
				            {text:''},
				            {text:''},
				            {text:''}
				        ],
				        stjx:''
				    };
					this.$validator.reset();
					this.$store.commit('setBreadcrumb',[{name:'题库管理'},{name:'新增试题'}]);
					this.stlbList = [{value: 'SINGLECHOICE', text: '单选题'}, {value: 'MULTIPLECHOICE', text: '多选题'}, {value: 'JUDGMENT', text: '判断题'}, {value: 'BLANKFILL', text: '填空题'}, {value: 'ESSAY', text: '问答题'}, {value: 'MCJST', text: '名词解释题'}, {value: 'LST', text: '论述题'}, {value: 'JDT', text: '简答题'}, {value: 'TT', text: '套题'}];//试题类别
					this.getsstkList();//题库
					this.stztList = [{value: 'OK', text: '开放'}, {value: 'BLOCK', text: '关闭'}];//试题状态
					this.stndList = [{value: 'FCRY', text: '非常容易'}, {value: 'BJRY', text: '比较容易'}, {value: 'CG', text: '常规'}, {value: 'JN', text: '较难'}, {value: 'FCN', text: '非常难'}];//试题难度
			},
            //提交
            save:function(){
                console.log('-----====model:',this.model);
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        let params = {};
                        params.stlb = this.model.stlb;
                        if(!params.stlb){
                            this.$error("请选择试题类别");
                            return;
                        }
                        params.tx = this.model.tx;
                        if(!params.tx){
                            this.$error("请选择题型");
                            return;
                        }
                        params.tkId = this.model.tkId;
                        if(!params.tkId){
                            this.$error("请选择所属题库");
                            return;
                        }
                        params.zt = this.model.zt;
                        if(!params.zt){
                            this.$error("请选择试题状态");
                            return;
                        }
                        params.stnd = this.model.stnd;
                        if(!params.stnd){
                            this.$error("请选择试题难度");
                            return;
                        }
                        params.sttg = this.model.sttg;
                        if(!params.sttg){
                            this.$error("请选择试题题干");
                            return;
                        }
                        if (this.model.stlb == 'SINGLECHOICE'){
                            //单选题答案
                            params.stda = this.model.stda;
                            if(!params.stda){
                                this.$error("请勾选试题答案");
                                return;
                            }
                            //单选题选项
                            params.options = [];
                            if(!this.model.options){
                                this.$error("单选题没有设置选项");
                                return;
                            }
                            let errors = [];
                            for (let i=0;i<this.model.options.length;i++) {
                                if(!this.model.options[i].text){
                                    errors.push("选项"+this.letters[i]+"没有输入选项内容");
                                }
                                else{
                                    params.options.push(this.model.options[i].text);
                                }
                            }
                            if(errors && errors.length > 0){
                                 this.$error(errors.join(","));
                                 return;
                            }
                            //以下参数为接口必传，所以取空值
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'MULTIPLECHOICE'){
                            //多选题
                            params.options = [];
                            let dxstda = [];
                            if(!this.model.options){
                                this.$error("多选题没有设置选项");
                                return;
                            }
                            let errors = [];
                            for (let i=0;i<this.model.options.length;i++) {
                                if(!this.model.options[i].text){
                                    errors.push("选项"+this.letters[i]+"没有输入选项内容");
                                }
                                else{
                                    params.options.push(this.model.options[i].text);
                                }
                                if(this.model.options[i].checked){
                                    dxstda.push(this.letters[i]);
                                }
                            }
                            if(errors && errors.length > 0){
                                this.$error(errors.join(","));
                                return;
                            }
                            if(!dxstda || dxstda.length==0){
                                this.$error("请勾选多选题答案");
                                return;
                            }
                            else{
                                params.stda = dxstda;
                            }
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'JUDGMENT'){
                            //判断题
                            params.stda = this.model.stda;
                            if(!params.stda){
                                this.$error("判断题没有设置答案");
                                return;
                            }
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'BLANKFILL'){
                            //填空题
                            if(!this.tktList || this.tktList.length==0){
                                this.$error("没有出现填空题");
                                return;
                            }
                            //判断是否有的空没有设置答案
                            let emptyBlanks = [];
                            this.tktList.forEach((item,index)=>{
                                if(!item.removed && !item.text){
                                    emptyBlanks.push('第'+(index+1)+'个空没有填写标准答案');
                                }
                            });
                            if(emptyBlanks.length > 0){
                                this.$error(emptyBlanks.join(','));
                                return ;
                            }
                            let tkts = this.tktList.filter(x=>{return !x.removed == true;});
                            if(!tkts || tkts.length==0){
                                this.$error("没有出现填空题");
                                return;
                            }
                            params.blanks = [];
                            params.blankids = [];
                            tkts.forEach((item,index)=>{
                                params.blankids.push(index+1);
                                params.blanks.push(tkts[index].text || '');
                            })
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'ESSAY'){
                            params.stda = this.model.stda;
                            if(!params.stda){
                                this.$error("没有设置问答题标准答案");
                                return;
                            }
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'MCJST'){
                            params.stda = this.model.stda;
                            if(!params.stda){
                                this.$error("没有设置名次解释题标准答案");
                                return;
                            }
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'LST'){
                            params.stda = this.model.stda;
                            if(!params.stda){
                                this.$error("没有设置论述题标准答案");
                                return;
                            }
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'JDT'){
                            params.stda = this.model.stda;
                            if(!params.stda){
                                this.$error("没有设置简答题标准答案");
                                return;
                            }
                            params.stfId = '';
                            params.stxh = '';
                        }
                        if (this.model.stlb == 'TT'){ //暂时不支持套题
                           	params.stda = this.model.stda;
                            params.stfId = '';
                            params.stxh = '';
                        }

                        //试题解析
                        params.stjx = this.model.stjx;
                        if(!params.stjx){
                            this.$error("请输入试题解析");
                            return;
                        }
                        params.stly= this.model.stly;
                        console.log('------params:',params);
                        if(params){
                            this.$http.post("/htgl/zktk/st/xz",JSON.stringify(params),{'Content-Type':'application/json;charset=UTF-8'}).then(res=>{
                                console.log('res-----:',res);
                                if(res.data){
                                    this.$success("新增试题成功",()=>{
										this.reset();
									});
                                }
                            });
                        }
                    }
                })
            }
        }

    }
</script>
<style scoped>
    .demo--label{
        margin:100px 0 0 0;
        display:inline-block
    }

    .demo--label_pd{
        margin:0 20px 0 0;
        display:inline-block
    }
    .demo--radio{
        display:none
    }
    .demo--radioInput{
        background-color:#fff;
        border:2px solid rgba(0,0,0,0.15);
        border-radius:100%;
        display:inline-block;
        height:30px;
        margin-right:10px;
        margin-top:-1px;
        vertical-align:middle;
        width:30px;
        line-height:1
    }
    .demo--radio:checked + .demo--radioInput:after{background-color:#00A1E9;border-radius:100%;content:"";display:inline-block;height:20px;margin-left:3px;margin-top:3px;width:20px}
    .demo--checkbox.demo--radioInput,.demo--radio:checked + .demo--checkbox.demo--radioInput:after{border-radius:0}
    .demo--radio:checked + .demo--radioInput{border:2px solid #00A1E9;}

    input[type="checkbox"] {
        width: 20px;
        height: 20px;
        background-color: #fff;
        -webkit-appearance: none;
        border: 1px solid #c9c9c9;
        border-radius: 2px;
        outline: none;
    }
    input[type="checkbox"]:checked {
        background: url(../../../assets/login/check.png)
        no-repeat center;
        background-size: 100% 100%;
    }
</style>
